export const getAnagraficaFromDB = `
query anagraficaFromDB($id:Int!,$userId:String!){
    getAnagraficaFromDB(id:$id,userId:$userId){                       
        addr2Cap    
        addr2Comune                  
        addr2ComuneId                
        addr2Indirizzo               
        addr2N                       
        addr2PaeseId                 
        addr2Provincia               
        addr2ProvinciaId             
        addrCap                      
        addrComune                   
        addrComuneId                 
        addrIndirizzo                
        addrN                        
        addrPaeseId                  
        addrProvincia                
        addrProvinciaId              
        amlId                        
        anagraficaId                 
        apCf                         
        apNome                       
        capSociale                   
        cf                           
        cognome                      
        countryCode                  
        createdBy                    
        createdOn                    
        denominazione                
        descAttivita                 
        docN                         
        docRilDa                     
        docRilData                   
        docScad                      
        docTipoId                    
        errWs                        
        errWsNote                    
        expiryDate                   
        genereId                     
        id                           
        identifiedByUser             
        identifiedOn                 
        importDesc                   
        isDeleted                    
        isNotPepMoreThanYear         
        isPep                        
        isPg                         
        modalitaIdentId              
        modifiedBy                   
        modifiedOn                   
        nascitaData                  
        nascitaLuogo                 
        nome                         
        office1Id                    
        office2Id                    
        orgAmmin                                          
        pepCarica                    
        pepRuolo                     
        pIva                         
        professione                  
        reaComune                    
        reaN                         
        revisionWs                   
        status                       
        tenantId                     
        tipoPatrimonioAltro          
        tipoPatrimonioId             
        tipoRedditoAltro             
        tipoRedditoId                
        versionDate                  
        versionN                     
        workspaceId 
        atecoCode
        attivitaLavDescr                  
    }
}`;
export const getAllAnagraficaVersions = `
query getAllAnagraficaVersions($id:Int!,$userId:String!,$versionN:Int){
    getAnagraficaVersionsFromDB(id:$id,userId:$userId,versionN:$versionN){
        addr2Comune                  
        addr2ComuneId                
        addr2Indirizzo               
        addr2N                       
        addr2PaeseId                 
        addr2Provincia               
        addr2ProvinciaId             
        addrCap                      
        addrComune                   
        addrComuneId                 
        addrIndirizzo                
        addrN                        
        addrPaeseId                  
        addrProvincia                
        addrProvinciaId              
        amlId                        
        anagraficaId                 
        apCf                         
        apNome                       
        capSociale                   
        cf                           
        cognome                      
        countryCode                  
        createdBy                    
        createdOn                    
        denominazione                
        descAttivita                 
        docN                         
        docRilDa                     
        docRilData                   
        docScad                      
        docTipoId                    
        errWs                        
        errWsNote                    
        expiryDate                   
        genereId                     
        id                           
        identifiedByUser             
        identifiedOn                 
        importDesc                   
        isDeleted                    
        isNotPepMoreThanYear         
        isPep                        
        isPg                         
        modalitaIdentId              
        modifiedBy                   
        modifiedOn                   
        nascitaData                  
        nascitaLuogo                 
        nome                         
        office1Id                    
        office2Id                    
        orgAmmin                                          
        pepCarica                    
        pepRuolo                     
        pIva                         
        professione                  
        reaComune                    
        reaN                         
        revisionWs                   
        status                       
        tenantId                     
        tipoPatrimonioAltro          
        tipoPatrimonioId             
        tipoRedditoAltro             
        tipoRedditoId                
        versionDate                  
        versionN                     
        workspaceId   
        atecoCode
        attivitaLavDescr                 
    }
}`;
export const query_anagrafiche_byFascicolo = `
query getAnagraficheByFascicolo($fascicoloId: Int!) {
  anagrafica(where: {anagrafica_fascicolos: {FascicoloId: {_eq: $fascicoloId}}, IsDeleted: {_eq: false}}, order_by: {Cf: desc, VersionN: desc}) {
    Id
    IsPg
    Cf
    Nome
    Cognome
    GenereId
    NascitaLuogo
    NascitaData
    Professione
    Denominazione
    PIva
    ReaComune
    ReaN
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    Addr2PaeseId
    Addr2ProvinciaId
    Addr2Provincia
    Addr2ComuneId
    Addr2Comune
    Addr2Indirizzo
    Addr2N
    Addr2Cap
    IsPep
    IsNotPepMoreThanYear
    PepCarica
    PepRuolo
    CreatedOn
    VersionN
    VersionDate
    IsDeleted
    CreatedBy
    ModifiedBy
    WorkspaceId
    AmlId
    Office1Id
    Office2Id
    TipoRedditoId
    TipoPatrimonioId
    CapSociale
    OrgAmmin
    DescAttivita
    TipoRedditoAltro
    TipoPatrimonioAltro
    ErrWs
    ErrWsNote
    CountryCode
    Status
    ExpiryDate
    RevisionWs
    ModalitaIdentId
    DocTipoId
    DocN
    DocRilDa
    DocRilData
    DocScad
    ApNome
    ApCf
    IdentifiedByUser
    IdentifiedOn
    AtecoCode
    AttivitaLavDescr
    anagrafica_bancadatis {
      Id
      Repository
      Infos
      CreatedOn
    }
    anagrafica_fascicolos(where: {FascicoloId: {_eq: $fascicoloId}}) {
      Id
      AnagraficaId
      FascicoloId
      TipoAnagId
      TipoPartId
      TipoPartDesc
      DataFine
      TipoRappId
      TipoRappDesc
      base_tipo_anagrafica {
        Id
        Key
        Value
      }
    }
  }
}`;
export const query_anagrafiche_byTenant = `
query getAnagraficheByTenant($tenantId: String!, $userId: String!) {
  anagrafica(
    where: {
      TenantId: { _eq: $tenantId },
      IsDeleted: { _eq: false },
      anagrafica_fascicolos: {
        _or: [
          { fascicolo: { IsPrivate: { _eq: false } } },
          { fascicolo: { prestaziones: { prestazione_user: { UserId: { _eq: $userId } } } } }
        ]
      }
    },
    order_by: { CreatedOn: desc }
  ) {
    Id
    Cf
  }
}`;
export const query_anagrafiche_byFiscalCode = `
query getAnagraficheByCf($tenantId: String!, $cf: String!) {
  anagrafica(where: {
    TenantId: {_eq: $tenantId}, IsDeleted: {_eq: false}, IsPg: {_eq: false}, Cf: {_ilike: $cf}
  }, order_by: {VersionN: desc}) {
    Id
    IsPg
    Cf
    Nome
    Cognome
    GenereId
    NascitaLuogo
    NascitaData
    Professione
    Denominazione
    PIva
    ReaComune
    ReaN
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    Addr2PaeseId
    Addr2ProvinciaId
    Addr2Provincia
    Addr2ComuneId
    Addr2Comune
    Addr2Indirizzo
    Addr2N
    Addr2Cap
    IsPep
    IsNotPepMoreThanYear
    PepCarica
    PepRuolo
    CreatedOn
    VersionN
    VersionDate
    IsDeleted
    CreatedBy
    ModifiedBy
    WorkspaceId
    AmlId
    Office1Id
    Office2Id
    TipoRedditoId
    TipoPatrimonioId
    CapSociale
    OrgAmmin
    DescAttivita
    TipoRedditoAltro
    TipoPatrimonioAltro
    anagrafica_fascicolos {
      Id
      fascicolo {
        Id
        Name
        Date
        CreatedBy
        ModifiedBy
      }
      base_tipo_anagrafica {
        Id
        Key
        Value
      }
      TipoPartId
      TipoPartDesc
    }
    anagrafica_bancadatis {
      Id
      Repository
      Infos
      CreatedOn
    }
  }
}`;
export const query_anagrafiche_byCf = `
query getAnagraficheByCf($tenantId: String!, $searchFilter: anagrafica_bool_exp!) {
  anagrafica(where: {
    TenantId: {_eq: $tenantId}, IsDeleted: {_eq: false}, IsPg: {_eq: false}, _and: [$searchFilter]
  }, order_by: {VersionN: desc}) {
    Id
    IsPg
    Cf
    Nome
    Cognome
    GenereId
    NascitaLuogo
    NascitaData
    Professione
    Denominazione
    PIva
    ReaComune
    ReaN
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    Addr2PaeseId
    Addr2ProvinciaId
    Addr2Provincia
    Addr2ComuneId
    Addr2Comune
    Addr2Indirizzo
    Addr2N
    Addr2Cap
    IsPep
    IsNotPepMoreThanYear
    PepCarica
    PepRuolo
    CreatedOn
    VersionN
    VersionDate
    IsDeleted
    CreatedBy
    ModifiedBy
    WorkspaceId
    AmlId
    Office1Id
    Office2Id
    TipoRedditoId
    TipoPatrimonioId
    CapSociale
    OrgAmmin
    DescAttivita
    TipoRedditoAltro
    TipoPatrimonioAltro
    IdentifiedByUser
    anagrafica_fascicolos {
      Id
      fascicolo {
        Id
        Name
        Date
        CreatedBy
        ModifiedBy
        AziendaId
      }
      base_tipo_anagrafica {
        Id
        Key
        Value
      }
      TipoPartId
      TipoPartDesc
    }
    anagrafica_bancadatis {
      Id
      Repository
      Infos
      CreatedOn
    }
  }
}`;
export const query_anagrafiche_byCf_PG = `
query getAnagraficheByCf($tenantId: String!, $searchFilter: anagrafica_bool_exp!) {
  anagrafica(where: {
    TenantId: {_eq: $tenantId}, IsDeleted: {_eq: false}, IsPg: {_eq: true}, _and: [$searchFilter]
  }, order_by: {VersionN: desc}) {
    Id
    IsPg
    Cf
    Nome
    Cognome
    GenereId
    NascitaLuogo
    NascitaData
    Professione
    Denominazione
    PIva
    ReaComune
    ReaN
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    Addr2PaeseId
    Addr2ProvinciaId
    Addr2Provincia
    Addr2ComuneId
    Addr2Comune
    Addr2Indirizzo
    Addr2N
    Addr2Cap
    IsPep
    IsNotPepMoreThanYear
    PepCarica
    PepRuolo
    CreatedOn
    VersionN
    VersionDate
    IsDeleted
    CreatedBy
    ModifiedBy
    WorkspaceId
    AmlId
    Office1Id
    Office2Id
    TipoRedditoId
    TipoPatrimonioId
    CapSociale
    OrgAmmin
    DescAttivita
    TipoRedditoAltro
    TipoPatrimonioAltro
    IdentifiedByUser
    anagrafica_fascicolos {
      Id
      fascicolo {
        Id
        Name
        Date
        CreatedBy
        ModifiedBy
        AziendaId
      }
      base_tipo_anagrafica {
        Id
        Key
        Value
      }
      TipoPartId
      TipoPartDesc
    }
    anagrafica_bancadatis {
      Id
      Repository
      Infos
      CreatedOn
    }
  }
}`;
export const query_anagrafiche_docInScadenza = `
query getFascicoloAnagraficheDocInScad($tenantId: String!,$aziendaId: Int!) {
  fascicolo(where: { TenantId: { _eq: $tenantId }, AziendaId: { _eq: $aziendaId } }) {
    prestaziones {
      Id
      EndDate
    }
    Id
    Name
    anagrafica_fascicolos {
      anagrafica {
        Id
        Denominazione
        DocScad
      }
    }
  }
}`;
export const query_anagrafiche_rel_fascicolo = `
query getAnagraficheRelFascicolo($anagraficaId: Int!) {
  anagrafica_fascicolo(where:
    {AnagraficaId: {_eq: $anagraficaId}}) {
      Id
      AnagraficaId
      FascicoloId
      TipoAnagId
      TipoPartId
      TipoPartDesc
      DataFine
  }
}`;
export const query_anagrafiche_malformed_Piva = `
query getAnagraficaPivaErrata($tenantId: String!, $aziendaId: Int!) {
  anagrafica(
    where: {
      PIva: { _regex: "^(?!\\\\d{11}$).+$" }
      IsPg: { _eq: true }
      TenantId: { _eq: $tenantId }
      anagrafica_fascicolos: {
        fascicolo: { AziendaId: { _eq: $aziendaId } }
      }
    }
    order_by: { Id: asc }
  ) {
    Id
    Cf
    PIva
    Denominazione
    IsPg   
    Nome
    Cognome
    GenereId
    NascitaLuogo
    NascitaData
    Professione    
    ReaComune
    ReaN
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    Addr2PaeseId
    Addr2ProvinciaId
    Addr2Provincia
    Addr2ComuneId
    Addr2Comune
    Addr2Indirizzo
    Addr2N
    Addr2Cap
    IsPep
    IsNotPepMoreThanYear
    PepCarica
    PepRuolo
    CreatedOn
    VersionN
    VersionDate
    IsDeleted
    CreatedBy
    ModifiedBy
    WorkspaceId
    Office1Id
    Office2Id
    AmlId
    IdentifiedOn
    IdentifiedByUser
    anagrafica_fascicolos {
      TipoAnagId
      TipoPartId
      fascicolo {
        Id
        Name
        Date
        AziendaId
      }
    }
  }
}`;
export const query_anagraficheIds_byFascicolo_Id = `
query getAnagraficheIdByFascicoloId($fascicoloId: Int!) {
  anagrafica(where: {anagrafica_fascicolos: {FascicoloId: {_eq: $fascicoloId}}, IsDeleted: {_eq: false}}, order_by: {Cf: desc, VersionN: desc}) {
    Id
  }
}`;
export const GET_ANAGRAFICA_DUPLICATES = `
query GetAnagraficaDuplicates($tenantId: String!) {
    getAnagraficaDuplicates(tenantId: $tenantId) {
        anagrafica {
            addr2Cap
            addr2Comune
            addr2ComuneId
            addr2Indirizzo
            addr2N
            addr2PaeseId
            addr2Provincia
            addr2ProvinciaId
            addrCap
            addrComune
            addrComuneId
            addrIndirizzo
            addrN
            addrPaeseId
            addrProvincia
            addrProvinciaId
            amlId
            anagraficaId
            apCf
            apNome
            atecoCode
            attivitaLavDescr
            capSociale
            cf
            cognome
            countryCode
            createdBy
            createdOn
            denominazione
            descAttivita
            docN
            docRilDa
            docRilData
            docScad
            docTipoId
            errWs
            errWsNote
            expiryDate
            genereId
            id
            identifiedByUser
            identifiedOn
            importDesc
            isDeleted
            isNotPepMoreThanYear
            isPep
            isPg
            modalitaIdentId
            modifiedBy
            modifiedOn
            nascitaData
            nascitaLuogo
            nome
            office1Id
            office2Id
            orgAmmin
            pepCarica
            pepRuolo
            pIva
            professione
            reaComune
            reaN
            revisionWs
            status
            tenantId
            tipoPatrimonioAltro
            tipoPatrimonioId
            tipoRedditoAltro
            tipoRedditoId
            versionDate
            versionN
            workspaceId
        }
        fascicoli {
            id
            name
        }
        aziende {
            id
            denominazione
        }
    }
}`;
export const query_ifThereAreDuplicates = `
query ifThereAreDuplicates($tenantId: String!) {
  ifThereAreDuplicates(tenantId: $tenantId) {
    userId
    authorized
    duplicated
  }
}`;
export const GET_ANAGRAFICHE_ORFANE = `
query getAnagraficheOrfane($tenantId: String!, $aziendaId: Int!) {
  getAnagraficheOrfane(tenantId: $tenantId, aziendaId: $aziendaId) {
    id
    cf
    nome
    cognome
    nascitaLuogo
    nascitaData
    professione
    denominazione
    pIva
    reaComune
    reaN
    addrProvincia
    addrComune
    addrIndirizzo
    addrN
    addrCap
    addr2Provincia
    addr2Comune
    addr2Indirizzo
    addr2N
    addr2Cap
    isPep
    isNotPepMoreThanYear
    createdOn
    versionN
    versionDate
    isPg
    addrPaeseId
    addrProvinciaId
    addrComuneId
    addr2PaeseId
    addr2ProvinciaId
    addr2ComuneId
    isDeleted
    genereId
    pepCarica
    createdBy
    modifiedBy
    modifiedOn
    tenantId
    importDesc
    workspaceId
    amlId
    office1Id
    office2Id
    pepRuolo
    tipoRedditoId
    tipoPatrimonioId
    capSociale
    orgAmmin
    descAttivita
    tipoRedditoAltro
    tipoPatrimonioAltro
    errWs
    errWsNote
    countryCode
    status
    expiryDate
    revisionWs
    modalitaIdentId
    docTipoId
    docN
    docRilDa
    docRilData
    docScad
    apNome
    apCf
    identifiedByUser
    identifiedOn
    anagraficaId
    atecoCode
    attivitaLavDescr
  }
}`;
export const get_ateco_base = `
query getAtecoBase {
  getAtecoBase {
    atecoCode
    atecoTitle
  }
}`;